import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  AuditLogDto,
  AuditLogQueryDto,
} from '../types/admin-api';

export const auditService = {
  getAll: async (query: AuditLogQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<AuditLogDto>>(
      '/audit',
      { params: query }
    );
    return response.data;
  },
};
